import { Dialog, Transition } from '@headlessui/react';
import { ReactNode } from 'react';

export interface DialogContainerProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onClose?: () => void;
  children: ReactNode;
}

/**
 * DialogContainer component for creating modal dialogs
 *
 * This component uses Headless UI's Dialog component to create accessible modal dialogs.
 * It handles the backdrop, transitions, and positioning of the dialog content.
 */
const DialogContainer = ({
  isOpen,
  setIsOpen,
  onClose = () => null,
  children,
}: DialogContainerProps) => {
  return (
    <Transition show={isOpen}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={() => {
          onClose();
          //setIsOpen(false);
        }}
      >
        {/* Backdrop */}
        <Transition.Child
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/75" />
        </Transition.Child>

        {/* Dialog content container */}
        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="max-h-[90vh] w-full transform overflow-y-auto rounded-2xl align-middle transition-all md:w-fit">
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default DialogContainer;
